/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import type { FC, SVGAttributes } from "react";

type Props = SVGAttributes<SVGElement>;

// FcWithoutChildren にしたいが props の定義が react に沿いきってないみたいでエラーが出るため FC を利用
export const CheckIcon: FC<Props> = (props: SVGAttributes<unknown>) => {
  return (
    <svg fill="none" viewBox="0 0 14 10" {...props}>
      <path
        d="M12.3337 1L5.00033 8.33333L1.66699 5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
